import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';

@Component({
    // Drop-in replacement selector
    selector: 'ngx-mat-select-search',
    standalone: false,
    template: `
    <mat-option class="ngx-mat-select-search-option" disabled>
      <div class="ngx-mat-select-search__container">
        <mat-icon *ngIf="searching" class="ngx-mat-select-search__spinner" svgIcon="autorenew"></mat-icon>
        <input
          matInput
          [placeholder]="placeholderLabel || 'Search...'"
          [formControl]="formControl"
          (keydown)="$event.stopPropagation()"
        />
        <button *ngIf="!hideClearSearchButton && formControl?.value" type="button" class="ngx-mat-select-search__clear" (click)="clear()" (keydown)="$event.stopPropagation()">×</button>
      </div>
      <div *ngIf="noFilter && !formControl?.value" class="ngx-mat-select-search__hint">{{ noEntriesFoundLabel }}</div>
      <div *ngIf="searching" class="ngx-mat-select-search__hint">{{ loadingLabel }}</div>
    </mat-option>
  `,
    styles: [
        `
    .ngx-mat-select-search-option { height: auto; padding-top: 4px; padding-bottom: 4px; }
    .ngx-mat-select-search__container { display: flex; align-items: center; gap: 6px; width: 100%; }
    .ngx-mat-select-search__spinner { animation: spin 1s linear infinite; }
    .ngx-mat-select-search__clear { background: transparent; border: none; cursor: pointer; font-size: 18px; line-height: 1; }
    .ngx-mat-select-search__hint { font-size: 12px; opacity: 0.66; margin-top: 2px; }
    @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
    `,
    ],
})
export class NgxMatSelectSearchShimComponent {
    // API compatibility surface (subset)
    @Input() formControl!: UntypedFormControl | null;
    @Input() placeholderLabel?: string;
    @Input() noEntriesFoundLabel?: string;
    @Input() loadingLabel?: string;
    @Input() searching = false;
    @Input() hideClearSearchButton = false;
    @Input() noFilter = false;
    @Input() preventHomeEndKeyPropagation = true; // kept for compatibility; handled by (keydown).stopPropagation

    clear(): void {
        if (this.formControl) {
            this.formControl.setValue('');
        }
    }
}

@NgModule({
    declarations: [NgxMatSelectSearchShimComponent],
    imports: [CommonModule, MatOptionModule, MatInputModule, MatIconModule, FormsModule, ReactiveFormsModule],
    exports: [NgxMatSelectSearchShimComponent],
})
export class NgxMatSelectSearchShimModule { }
